import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "react-builder";
import { ConfigsProvider } from "react-builder";
import { useContext } from "react";
import { DomainConfigContext, IPricingPackage } from "react-builder";
import { AuthContext } from "react-builder";

@AttributeGroup({ title: 'PricingProvider', blockName: 'PricingProvider', module: 'domain' })
export class PricingProviderAttributes extends Attribute {

}

const PricingProviderTheme = styled.div((props: { attributes: PricingProviderAttributes }) => `

    ${props.attributes.toCSS()}

`);

function PricingProvider(props: ComponentProps<PricingProviderAttributes>) {

    const { setSelectedPackage } = useContext(AuthContext);
    const domainConfig = useContext(DomainConfigContext);

    const getPrice = (p: IPricingPackage) => {
        return parseFloat(p.trialPrice) || parseFloat(p.price);
    }

    const prices = domainConfig?.companyInfo?.prices.sort((a, b) => a.orderId - b.orderId).map((p) => ({ ...p, select: () => setSelectedPackage(p) }));
    return (
        <PricingProviderTheme attributes={props.attributes}>
            <ConfigsProvider configJson={{ pricing: prices }}>
                <>
                    {props.children}
                </>
            </ConfigsProvider>

        </PricingProviderTheme>
    )
}


PricingProvider.prototype.Props = PricingProviderAttributes;


export default PricingProvider;